<div
  [class.sidebar]="boardLayout && boardLayout.keyboardPosition === SudokuKeyboardPositions.RIGHT"
  class="sudoku-screen"
>
  <!-- Catching the clicks outside of the board to deselect currently selected or highlighted tiles.-->
  <div class="deselector" (click)="deselectUnhighlight()"></div>
  <div #sudokuBoard class="sudoku-board">
    <div
      [style.height.px]="this.boardLayout.puzzleScale * this.boardHeight"
      [style.width.px]="this.boardLayout.puzzleScale * this.boardWidth"
      class="sudoku-container"
    >
      <div
        *ngIf="initialized && borderLogicGroups.length !== 0" [style.height.px]="boardHeight"
        [style.transform]="this.boardLayout ? 'scale(' + this.boardLayout.puzzleScale + ')' : 'none'"
        [style.width.px]="boardWidth"
        class="sudoku-grid"
      >
        <div *ngFor="let row of tiles" class="sudoku-row">
          <div
            (click)="onTileClicked($event, tile)"
            *ngFor="let tile of row"
            [ngClass]="tile.borders"
            class="sudoku-tile"
          >
            <div
              [class.conflict]="tile.conflictingTiles.length !== 0"
              [class.highlight-logic-group]="highlightLogicGroup(tile)"
              [class.highlight]="userInput[tile.index] === highlightValue"
              [class.user-selected]="this.selectedIndex === tile.index"
              [class.note-mode]="this.notesMode"
              class="tile-content"
            >
              <div *ngIf="tile.exposed" class="tile-exposed">{{tile.text}}</div>
              <div
                *ngIf="!tile.exposed"
                [class.wrong]="highlightWrong && userInput[tile.index] !== tile.text"
                class="tile-input tile-input-highlight"
              >
                <div class="tile-input-inner">{{userInput[tile.index]}}</div>
              </div>
            </div>
            <div
              *ngIf="!userInput[tile.index]"
              class="tile-notes"
              [class.user-selected]="this.selectedIndex === tile.index"
            >
              <div
                *ngFor="let char of allowedChars" [class.highlight]="char === highlightValue"
                [style.height.%]="100/borderLogicRows"
                [style.width.%]="100/borderLogicCols"
                class="tile-note"
              >
                <div
                  *ngIf="tile.notes.indexOf(char)!==-1"
                  [class.not-allowed]="!noteAllowed(tile, char)"
                  class="note-content"
                >
                  {{char}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    [class.sidebar]="boardLayout && boardLayout.keyboardPosition === SudokuKeyboardPositions.RIGHT"
    [style.height.px]="boardLayout.keyboardPosition === SudokuKeyboardPositions.RIGHT ? undefined : boardLayout.keyboardSize"
    [style.width.px]="boardLayout.keyboardPosition === SudokuKeyboardPositions.RIGHT ? boardLayout.keyboardSize : undefined"
    class="sudoku-footer puzzle-elevation-z3"
  >
    <lib-app-sudoku-keyboard
      (puzzleKeyPressed)="onKeyPressed($event)"
      [disableDeleteButton]="disableDeleteButton()"
      [enabledInputs]="enabledInputs" [keyboardLayout]="boardLayout.keyboardLayout"
    />
  </div>
</div>
